import React from 'react';
import Loading from '../components/loading';

const LoadingTemplate = () => {
  return <div className="text-center confirmation-loading">
    <p>Validating token. Please bear with us!</p>
    <Loading />
  </div>;
};
export default LoadingTemplate;



// WEBPACK FOOTER //
// ./src/confirmation/loading-template.js